import PortfolioCard from './PortfolioCard'
import LoadingBlocker from '../../components/LoadingSpinner/LoadingBlocker'

const PortfolioList = ({
  portfolios,
  onPortfolioClick,
  onPortfolioDoubleClick,
  selectedPortfolios = [],
  isLoading,
  search,
}) => {
  return (
    <div className="">
      {portfolios?.length > 0 ? (
        portfolios.map((portfolio, i) => {
          return (
            <PortfolioCard
              key={portfolio.id}
              portfolio={portfolio}
              index={i}
              onPortfolioClick={onPortfolioClick}
              onPortfolioDoubleClick={onPortfolioDoubleClick}
              selectedPortfolios={selectedPortfolios}
            />
          )
        })
      ) : (
        <>
          <div className="mt-6 p-6 mx-8 bg-gray border border-gray-dark rounded">
            {!search ? (
              <>
                <h4 className="mb-4">No Portfolios</h4>
                <p>Create a portfolio to get started!</p>
              </>
            ) : (
              <>
                <h4 className="mb-4">No Portfolios Found</h4>
                <p>There is no portfolios found match your search.</p>
              </>
            )}
          </div>
        </>
      )}
      {isLoading && <LoadingBlocker />}
    </div>
  )
}

export default PortfolioList
